export default __webpack_public_path__ + "static/media/spinner.51121806.gif";